module.exports = __webpack_public_path__ + "img/logo.c5543624.png";